import React from 'react';
import { motion } from 'framer-motion';
import { Car, Laptop, Star, Wrench } from 'lucide-react';
const personas = [{
  icon: Car,
  title: 'The Enthusiast',
  description: 'Your collection deserves better than a driveway. Climate-controlled protection for your classics, off-roaders, or RVs.'
}, {
  icon: Laptop,
  title: 'The Remote Pro',
  description: 'Separate your work life from home life. The detached studio offers silence, focus, and zero commute.'
}, {
  icon: Star,
  title: 'The Privacy Seeker',
  description: 'Enjoy your morning coffee with only the mountains as your neighbor. True solitude minutes from amenities.'
}, {
  icon: Wrench,
  title: 'The Maker',
  description: 'Woodworking, metal fabrication, or art. A dedicated industrial space where you can make noise and create.'
}];
export function BuyerPersonas() {
  return <section id="lifestyle" className="py-20 bg-white" data-id="element-18">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-19">
        <div className="text-center mb-16" data-id="element-20">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#2D2D2D] mb-4" data-id="element-21">
            Who This Property Is For
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-22">
            Designed for those who need more than just a bedroom and a kitchen.
            This estate supports your passions.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-23">
          {personas.map((persona, index) => <motion.div key={persona.title} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group p-6 bg-[#FAF8F5] rounded-xl border border-transparent hover:border-[#E8DCC4] transition-all duration-300" data-id="element-24">
              <div className="w-14 h-14 bg-white rounded-full flex items-center justify-center mb-6 shadow-sm text-[#C1694F] group-hover:scale-110 transition-transform duration-300" data-id="element-25">
                <persona.icon size={28} strokeWidth={1.5} data-id="element-26" />
              </div>
              <h3 className="text-xl font-serif font-bold text-[#2D2D2D] mb-3" data-id="element-27">
                {persona.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-28">
                {persona.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}